import { render } from "./projectManage.vue?vue&type=template&id=187e6f72&scoped=true&ts=true"
import script from "./projectManage.vue?vue&type=script&lang=ts"
export * from "./projectManage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187e6f72"]])

export default __exports__